import React, { Component } from 'react'
import arrowBottom from '../../assets/arrow-bottom.png'
import arrowRight from '../../assets/arrow-right.png'
import { Link } from 'react-router-dom'

class RewardInfo extends Component {
	constructor(props) {
		super(props)
		this.state = {
			data: null,
			expandAboutQuickPayoff: false,
			expandAboutPayoffDate: false,
			expandAboutInvoice: false,
		}
	}



	render() {
		return (
			<div style={{ display: 'block', flex: 1, fontFamily: 'Hiragino Kaku Gothic Pro' }}>
				<div className="primary-content">
					<div className="primary-content__body">
						<div className="primary-title lv_2">
							<h1 className="primary-title__main">インボイス登録番号の申請</h1>
						</div>
						<div className="" style={{ marginBottom: 25 }}>
							<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
								<div className='tab_invoice_reward'>
									状態
								</div>
								<div>
									<p style={{ color: this.props.is_regis_invoice ? '#212121' : '#ec407a', fontSize: 16, paddingBlock: 6, paddingInline: 20, textAlign: 'left' }}>{this.props.is_regis_invoice ? '申請済み' : '未申請'}</p>
									{!this.props.is_regis_invoice && <Link to={'/home/contact'} className='btn_res_invoice'>インボイス登録を申請</Link>}
								</div>
							</div>

							{/* {!this.props.is_regis_invoice && <div className='note-invoice'>適格請求書発行事業者の登録を行っている方は、<br /> <Link to={'/home/contact'}>お問い合わせ</Link>より登録番号の申請を行うようお願いいたします。</div>} */}
						</div>
						<div className="about-invoice">
							<div onClick={() => this.setState({
								expandAboutQuickPayoff: !this.state.expandAboutQuickPayoff
							})} className="lv_2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>

								<span style={{ fontWeight: '600' }}>
									{this.props.isAutoPayoff ? '定期精算について' : 'クイック精算について'}
								</span>
								<img
									alt={''}
									src={this.state.expandAboutQuickPayoff ? arrowBottom : arrowRight}
									style={{ width: 12, height: 12, margin: 0 }}
								/>

							</div>
							{this.state.expandAboutQuickPayoff && <div style={{ fontSize: 13, gap: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: 16 }}>
								<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
									<div className='tab_invoice_reward'>
										最低精算額
									</div>
									<div style={{ paddingInline: 20, color: '#262626' }}>
										5,550円（初回3,350円）
									</div>

								</div>
								<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
									<div className='tab_invoice_reward'>
										支払日
									</div>
									<div style={{ paddingInline: 20, color: '#262626' }}>
										{this.props.isAutoPayoff ? '毎月5〜10日頃' : '精算申請日から2営業日'}
									</div>
								</div>
								<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
									<div className='tab_invoice_reward'>
										振込名義
									</div>
									<div style={{ paddingInline: 20, color: '#262626' }}>
										カ）ステラ
									</div>
								</div>
								<ul style={{ listStyle: 'none', marginTop: 16, alignSelf: 'flex-start', display: 'flex', flexDirection: 'column', paddingLeft: 10 }}>
									{(this.props.isAutoPayoff
										? ['毎月5日午前中に自動で精算申請が行われます', '4日までに必ず口座情報が正しいかご確認ください', '最長10日17:00までに振込完了となります', '精算申請後のキャンセルは受付できない場合がございます', '口座情報が誤っていた場合、組戻手数料(880pt)が発生する可能性があります', '30日間ログインがなかった場合、口座情報の更新確認が行われるため、再ログイン後に申請が可能となります。']
										: ['定期精算のオプションとして併用が可能です（事務手数料550pt）', '精算申請後のキャンセルは受付できない場合がございます', '口座情報が誤っていた場合、組戻手数料(880pt)が発生する可能性があります', '定期精算の処理中はクイック精算がご利用いただけません']
									).map((text, i) => (
										<li key={i}
											style={{
												display: 'flex',
												alignItems: 'flex-start',
												gap: 8, textAlign: 'left',
												fontWeight: this.props.isAutoPayoff && i === 0 ? '600' : '300',
												color: '#000',
												fontFamily: 'Hiragino Kaku Gothic Pro',
											}}>
											<span style={{ width: 2, height: 2, borderRadius: '50%', backgroundColor: 'currentColor', flexShrink: 0, display: 'inline-block', marginTop: 8 }} />
											{text}
										</li>
									))}
								</ul>
							</div>}
						</div>
						{!this.props.isAutoPayoff && <div className="about-invoice" style={{ marginTop: 16 }}>
							<div onClick={() => this.setState({
								expandAboutPayoffDate: !this.state.expandAboutPayoffDate
							})} className="lv_2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>

								<span style={{ fontWeight: '600' }}>
									支払日について
								</span>
								<img
									alt={''}
									src={this.state.expandAboutPayoffDate ? arrowBottom : arrowRight}
									style={{ width: 12, height: 12, margin: 0 }}
								/>

							</div>
							<div className="frame-table second-table" style={{ display: this.state.expandAboutPayoffDate ? 'block' : 'none', marginTop: 16 }}>
								<table className="table-th-head">
									<thead>
										<tr>
											<th className="table-align-center" style={{ width: 120, fontSize: 12, fontWeight: '600', color: '#262626' }}>
												精算ボタンを押した日
											</th>
											<th className="table-align-center" style={{ fontSize: 13, fontWeight: '600', color: '#262626' }}>
												口座への入金日時
											</th>
										</tr>
									</thead>
									<tbody >
										<tr >
											<td className="table-align-center tab__label_payment">
												月曜日
											</td>
											<td className="table-align-center tab__label_payment">
												水曜日の9時〜15時
											</td>
										</tr>
										<tr>
											<td className="table-align-center tab__label_payment">
												火曜日
											</td>
											<td className="table-align-center tab__label_payment">
												木曜日の9時〜15時
											</td>
										</tr>
										<tr>
											<td className="table-align-center tab__label_payment">
												水曜日
											</td>
											<td className="table-align-center tab__label_payment">
												金曜日の9時〜15時
											</td>
										</tr>
										<tr>
											<td className="table-align-center tab__label_payment">
												木曜日
											</td>
											<td className="table-align-center tab__label_payment">
												翌週月曜日の9時〜15時
											</td>
										</tr>
										<tr>
											<td className="table-align-center tab__label_payment">
												金曜日
											</td>
											<td className="table-align-center tab__label_payment">
												翌週火曜日の9時〜15時
											</td>
										</tr>
										<tr>
											<td className="table-align-center tab__label_payment">
												土曜日
											</td>
											<td className="table-align-center tab__label_payment">
												翌週火曜日の9時〜15時
											</td>
										</tr>
										<tr>
											<td className="table-align-center tab__label_payment">
												日曜日
											</td>
											<td className="table-align-center tab__label_payment">
												翌週火曜日の9時〜15時
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>}
						{!this.props.is_regis_invoice && <div className="about-invoice" style={{ marginTop: 16 }}>
							<div onClick={() => this.setState({
								expandAboutInvoice: !this.state.expandAboutInvoice
							})} className="lv_2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>

								<span style={{ fontWeight: '600' }}>
									インボイス登録について
								</span>
								<img
									alt={''}
									src={this.state.expandAboutInvoice ? arrowBottom : arrowRight}
									style={{ width: 12, height: 12, margin: 0 }}
								/>

							</div>
							{this.state.expandAboutInvoice && <div style={{ fontSize: 13, marginTop: 16, lineHeight: '1.8', color: '#262626', fontWeight: '300', textAlign: 'left' }}>
								<p>インボイス発行事業者として登録すると、税務署から「T」から始まる登録番号が発行されます。登録番号をお持ちの方は、必ずStellaへご申請ください。</p>
								<p style={{ marginTop: 8 }}>また、インボイス登録後に登録を取り消した場合も、必ずStellaへご連絡ください。</p>
								<p style={{ marginTop: 8 }}>Stellaでは、インボイス登録番号の取得・未取得にかかわらず、お仕事をしていただき、報酬をお受け取りいただけます。</p>
								<p style={{ marginTop: 8 }}>ただし、Stellaで有効なインボイス登録番号が確認できない方には、報酬のお支払い時に「インボイス制度調整額」が差し引かれます。</p>
								<p style={{ marginTop: 8 }}>これは、インボイス制度により弊社で控除できない消費税相当額の負担が弊社側で発生するため、その負担額を調整するものです。</p>
								<p style={{ marginTop: 8 }}>インボイス登録や納税など、個別の税務に関するご相談については、国税庁のインボイス制度特設サイトや所轄の税務署等へお問い合わせください。</p>
								<p style={{ marginTop: 8 }}>Stellaからのお支払いや利用規約などに関するお問い合わせは、お問い合わせフォームよりご連絡ください。</p>
							</div>}
						</div>}
					</div>
				</div>
			</div >
		)
	}
}

export default RewardInfo
